<template>
  <svg aria-hidden="true" width="24" height="24" fill="none" viewBox="0 0 24 24" ...attributes>
    <circle cx="12" cy="12" r="3.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></circle>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M12 2.75V4.25"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M17.25 6.75L16.0659 7.93416"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M21.25 12.0001L19.75 12.0001"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M17.25 17.2501L16.0659 16.066"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M12 19.75V21.25"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M7.9341 16.0659L6.74996 17.25"></path>
    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M4.25 12.0001L2.75 12.0001"></path>
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M7.93405 7.93423L6.74991 6.75003"
    ></path>
  </svg>
</template>
